"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _ImageBase = _interopRequireDefault(require("./ImageBase"));

var _ImageAnnotationsMarkerDefault = _interopRequireDefault(require("./ImageAnnotationsMarkerDefault"));

var _reactResizeDetector = require("react-resize-detector");

var _getImagePoint = require("./utils/getImagePoint");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  list: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
}));

const ImageAnnotations = (_ref) => {
  let className = _ref.className,
      imageUrl = _ref.imageUrl,
      _ref$imageCropdata = _ref.imageCropdata,
      imageCropdata = _ref$imageCropdata === void 0 ? {} : _ref$imageCropdata,
      _ref$imageFocalpoint = _ref.imageFocalpoint,
      imageFocalpoint = _ref$imageFocalpoint === void 0 ? {} : _ref$imageFocalpoint,
      _ref$imageFilters = _ref.imageFilters,
      imageFilters = _ref$imageFilters === void 0 ? {} : _ref$imageFilters,
      _ref$imageAnnotations = _ref.imageAnnotations,
      imageAnnotations = _ref$imageAnnotations === void 0 ? [] : _ref$imageAnnotations,
      markerTemplate = _ref.markerTemplate,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "imageUrl", "imageCropdata", "imageFocalpoint", "imageFilters", "imageAnnotations", "markerTemplate", "onChange"]);

  const _useState = (0, _react.useState)(false),
        isDragging = _useState[0],
        setIsDragging = _useState[1];

  const _useState2 = (0, _react.useState)(false),
        parentRef = _useState2[0],
        setParentRef = _useState2[1];

  const handleLoad = ({
    cropboxRef
  }) => {
    setParentRef(cropboxRef);
  };

  const handleClick = event => {
    const point = (0, _getImagePoint.getImagePointEvent)(event);
    setIsDragging(false);
    let newFormData;

    if (imageAnnotations.length) {
      newFormData = [...imageAnnotations, point];
    } else {
      newFormData = [point];
    }

    onChange && onChange(newFormData);
  };

  const handleIndexChange = (data, index) => {
    const marker = _extends({}, imageAnnotations[index], {}, data);

    const newFormData = imageAnnotations.map((item, i) => {
      const jsonValue = typeof marker === "undefined" ? null : marker;
      return index === i ? jsonValue : item;
    });
    onChange && onChange(newFormData);
  };

  let MarkerTemplate;

  if (markerTemplate) {
    MarkerTemplate = markerTemplate;
  } else {
    MarkerTemplate = _ImageAnnotationsMarkerDefault.default;
  }

  const classes = useStyles();
  const MarkerList = (0, _reactResizeDetector.withResizeDetector)(({
    width,
    height
  }) => {
    const handleStart = (event, data, index) => {
      setIsDragging(true);
    };

    const handleDrag = (event, data, index) => {//        setIsDragging(true)
    };

    const handleStop = (event, data, index) => {
      const x = data.x;
      const y = data.y;
      const left = x / width * 100;
      const top = y / height * 100;
      const fx = (x / width - 0.5) * 2;
      const fy = (y / height - 0.5) * -2;
      const coords = {
        left: left,
        top: top,
        x: fx,
        y: fy
      };
      console.log('COORDS', coords);
      handleIndexChange(coords, index);
      setIsDragging(false);
    };

    return _react.default.createElement("div", {
      className: classes.list,
      onClick: !isDragging ? onChange && handleClick : undefined
    }, imageAnnotations && imageAnnotations.length && imageAnnotations.map((marker, index) => {
      const left = marker.left || 0;
      const top = marker.top || 0;
      const x = left * width / 100;
      const y = top * height / 100;

      if (!onChange) {
        return _react.default.createElement(MarkerTemplate, _extends({}, marker, {
          index: index,
          key: index,
          position: {
            x: x,
            y: y
          }
        }));
      }

      return _react.default.createElement(MarkerTemplate, _extends({}, marker, {
        index: index,
        key: index,
        position: {
          x: x,
          y: y
        },
        onStart: (event, data) => handleStart(event, data, index),
        onDrag: (event, data) => handleDrag(event, data, index),
        onStop: (event, data) => handleStop(event, data, index)
      }));
    }) || "");
  });
  return _react.default.createElement(_ImageBase.default, _extends({
    className: className || classes.root
  }, props, {
    imageUrl: imageUrl,
    imageCropdata: imageCropdata,
    imageFocalpoint: imageFocalpoint,
    imageFilters: imageFilters,
    onLoad: handleLoad
  }), _react.default.createElement(MarkerList, null));
};

var _default = ImageAnnotations;
exports.default = _default;
module.exports = exports.default;